const project = [

  {
    id: 3,
    image: "./assets/3.jpg",
    links: "https://github.com/iamrishavraj1/Rasayanatva-project",
  },
  {
    id: 4,
    image: "./assets/4.jpg",
    links: "https://github.com/iamrishavraj1/b2b",
  },
  {
    id: 5,
    image: "./assets/5.jpg",
    links: "https://github.com/iamrishavraj1/PFF-project",
  },
  {
    id: 6,
    image: "./assets/6.jpg",
    links: "https://github.com/iamrishavraj1/TSF",
  },
];

export default project;
